import { Component, Input } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'message',
    template: require('./message.component.html'),
    styles: [require('./message.component.css')]
})

export class MessageComponent  {
    @Input() dialog: DialogRef;
    @Input() message: string;

    btnClicked(event) {
        this.closeWindow(true);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/message.component.ts